

















import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import Hamburger from '@/components/Hamburger/index.vue';
import Breadcrumb from '@/components/Breadcrumb/index.vue';

@Component({
  name: 'Navbar',
  components: {
    Hamburger,
    Breadcrumb,
  },
})
export default class extends Vue {
  isLangCn: boolean = true;

  get sidebar() {
    return AppModule.sidebar;
  }

  get device() {
    return AppModule.device.toString();
  }

  mounted() {
    if (window.location.href.replace('//', '').split('/')[1] !== 'en') {
      this.isLangCn = true;
    } else {
      this.isLangCn = false;
    }
  }

  async toggleLang() {
    try {
      await this.$confirm('即将离开页面，请确保填写内容均已保存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      });
      if (this.isLangCn) {
        if (UserModule.isSuperadmin) {
          window.location.href = window.location.origin + '/en/admin';
        } else {
          UserModule.LogOut();
          window.location.href = window.location.origin + '/en/admin/login';
        }
      } else {
        if (UserModule.isSuperadmin) {
          window.location.href = window.location.origin + '/admin';
        } else {
          UserModule.LogOut();
          window.location.href = window.location.origin + '/admin/login';
        }
      }
    } catch (error) {
      //
    }
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }

  private async logout() {
    await UserModule.LogOut();
    this.$router.push(`/login?redirect=${this.$route.fullPath}`);
  }
}
